
export type State = {
  lastKnownStatus: number|null,
}
export const state: State = {
  lastKnownStatus: null
}
